import { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import api from '../api/axios';

export default function LogPage() {
  const [search, setSearch] = useState('');
  const [filteredLog, setFilteredLog] = useState([]);
  const [logs, setLogs] = useState([]);
  const [loadingTable, setLoadingTable] = useState(false);

  useEffect(() => {
   fetchLogs();
  }, []);

  const normalizeText = (text) => {
    return text
      ?.toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, ""); // quita acentos
  };

  const fetchLogs = async () => {
    try {
      setLoadingTable(true);
      const res = await api.get("/logs/list");
      setLogs(res.data.data)
      setFilteredLog(res.data.data);
     
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingTable(false);
    }
  };

  useEffect(() => {
    const result = logs.filter(item =>
      normalizeText(item.user?.name)?.includes(normalizeText(search)) ||
      normalizeText(item.action)?.includes(normalizeText(search)) ||
      normalizeText(item.created_at)?.includes(normalizeText(search))
    );
    setFilteredLog(result);
  }, [search, logs]);

  const columns = [
    { name: 'Usuario', selector: row => row.user?.name, sortable: true },
    { name: 'Acción', selector: row => row.action, sortable: true },
    { name: 'Fecha registro',
      selector: row => {
      const d = new Date(row.created_at);
      return d.toLocaleDateString() + ' ' + d.toLocaleTimeString();
    }, sortable: true },
  ];

  return (
    <div className="mt-4">
      <DataTable
        title="Listado de logs registrados "
        columns={columns}
        data={filteredLog}
        pagination
        highlightOnHover
        responsive
        striped
        subHeader
        progressPending={loadingTable}
        progressComponent={
          <div className="text-center p-3">
            <div className="spinner-border text-primary"></div>
            <p>Cargando...</p>
          </div>
        }
        subHeaderComponent={
          <div className="d-flex justify-content-between w-100">
            <input
              type="text"
              className="form-control w-25"
              placeholder="Buscar..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        }
      />
    </div>
    
  );
}
